import bramidanTerms from 'assets/terms-and-conditions/bramidan_terms_and_conditions_V1.pdf';
import React from 'react';

export const termsAndConditionsPdf = () => {
	return (
		<object data={bramidanTerms} type="application/pdf" style={{ width: '100vw', height: '100vh' }}>
			<p>
				Unable to display PDF file. <a href={bramidanTerms}> Download </a> instead.
			</p>
		</object>
	);
};
